module.exports = __webpack_public_path__ + "assets/popup-maker.043ebce5.svg";